import React from "react";
import { ListGroup } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import data from "./_setup.json";

const Autocomplete = (props) => {
  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };
  return (
    <ListGroup id="autocomplete-result" as="ul" className="shadow-sm">
      {props.results.map((post, i) => (
        <ListGroup.Item
          as="li"
          className={i === props.activeIndex ? "active" : ""}
        >
          <a
            href={"/" + data.url.slug_posts + "/" + post.slug + "/"}
            style={{ textDecoration: "none" }}
          >
            {decodeHtml(post.title.rendered)}
          </a>
          <Outlet></Outlet>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default Autocomplete;
